import { createContext, PropsWithChildren, useContext } from "react";
import { Step } from "~/lib/pipeline";
import { Job, RetryableJob } from "~/components/build/Show/lib/types";

type StepDrawerContextValue = {
  step?: Step;
  job?: RetryableJob;
  jobs: Job[];
  retries: RetryableJob[];
};

const StepDrawerContext = createContext<StepDrawerContextValue | null>(null);

export function StepDrawerProvider({
  children,
  ...value
}: PropsWithChildren<StepDrawerContextValue>) {
  return <StepDrawerContext.Provider value={value}>{children}</StepDrawerContext.Provider>;
}

export function useStepDrawer(): StepDrawerContextValue {
  const context = useContext(StepDrawerContext);

  if (!context) {
    throw new Error("useStepDrawer() must be used within a <StepDrawerProvider />");
  }

  return context;
}
